// src/i18n.ts

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Los idiomas base que soportamos
const availableLanguages = ['es', 'en'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)

  .init({
    fallbackLng: 'es', 
    
    lng: 'es', // Forzar español por defecto
   
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      crossDomain: false,
    },
    
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },
    
    supportedLngs: availableLanguages,
    
    nonExplicitSupportedLngs: true,
    
    ns: ['translation'],
    defaultNS: 'translation',

    debug: true, // Activar debug temporalmente para ver qué pasa
    
    interpolation: {
      escapeValue: false, 
    },
    
    react: {
      useSuspense: false, // Desactivar suspense para evitar problemas de carga
    },
    
  });

export default i18n;